import {
  NATIF_GENERIC_DOCUMENT_TAG_MAP,
  NATIF_N26_DOCUMENT_TAG_MAP,
  NATIF_SENDER_TAG_MAP,
} from '@getcaya/document-ingestion-util'

interface Tags {
  allAvailableTags: string[]
  documentTypeTags: string[]
  senderTypeTags: string[]
}

const useGetDocumentTags = (): Tags => {
  const documentTypeTags = [
    // N26 Tags need to be on top
    ...Object.values(NATIF_N26_DOCUMENT_TAG_MAP),
    ...Object.values(NATIF_GENERIC_DOCUMENT_TAG_MAP),
  ]
  const senderTypeTags = Object.values(NATIF_SENDER_TAG_MAP)
  const allAvailableTags = [...documentTypeTags, ...senderTypeTags]
  return {
    allAvailableTags,
    documentTypeTags,
    senderTypeTags,
  }
}

export default useGetDocumentTags
